// extracted by mini-css-extract-plugin
module.exports = {"field":"_3X6HYN","input":"_2_PlgL","switchLabel":"_385zMx","label":"_3u4JsN","horizontal":"_2KhEU_","button":"_3KdWiY"};